var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "voucher-porto" }, [
      _c("p", { staticClass: "voucher-porto__hint" }, [
        _vm._v("*" + _vm._s(_vm.$t("vouchers.portoHint"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "voucher-list__bottom" }, [
      _c(
        "div",
        { staticClass: "voucher-list__choice" },
        [
          _vm._l(_vm.basket, function (item, i) {
            return _c("div", { staticClass: "voucher-list__chosen" }, [
              _c("span", [_vm._v(_vm._s(item.title))]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(item.quantity) +
                    "x " +
                    _vm._s(_vm.formatPrice(item.price, "long"))
                ),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.shippingCosts
            ? _c("div", { staticClass: "voucher-list__chosen" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("vouchers.portoTitle")))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatPrice(_vm.shippingCosts, "long"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "voucher-list__summary",
              class: { "voucher-list__summary--active": _vm.totalQuantity },
            },
            [
              _c("h3", { staticClass: "voucher-list__sum" }, [
                _vm._v(_vm._s(_vm.$t("vouchers.sum"))),
              ]),
              _vm._v(" "),
              _c("h3", {}, [
                _vm._v(_vm._s(_vm.formatPrice(_vm.total, "long"))),
              ]),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasBigVoucher
        ? _c("div", { staticClass: "voucher-message" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("vouchers.bigVoucherMessage")))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.shippingCosts,
            expression: "shippingCosts",
            modifiers: { number: true },
          },
        ],
        attrs: { name: `shippingCost`, type: "hidden" },
        domProps: { value: _vm.shippingCosts },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.shippingCosts = _vm._n($event.target.value)
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }